/*
 * @Author: your name
 * @Date: 2020-10-13 14:28:22
 * @LastEditTime: 2022-11-16 17:24:17
 * @LastEditors: pj
 * @Description: In User Settings Edit
 * @FilePath: \fp_h5\src\store\modules\devicelog\devicelog.js
 */
import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        searchP: {
            dingdingname: ''
        },
        list: [],
        pagination: {

        },
        record: {
            shopcode: '',
            devicekeyword: '',
            syscode: '',
        },//
    },

    getters: {
        getDomainnameSelectOptions (state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save (state, action) {
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },

    actions: {

        //  查询钉钉列表
        searchDingdingPage (context, payload) {
            return D.select({
                ...payload
            })
        },
        relatedkey (context, payload) {
            return D.add({
                ...payload
            })
        },
        delkey (context, payload) {
            return D.del({
                ...payload
            })
        },
        querykeyspage (context, payload) {
            return D.select({
                ...payload
            })
        },

        // 列表
        dingdinglist (context, payload) {
            return D.select({
                ...payload
            })

        },
        //  修改
        dingdingedit (context, payload) {
            return D.edit({
                ...payload
            })

        },
        //  删除
        dingdingdel (context, payload) {
            return D.edit({
                ...payload
            })
        },
        //  新增
        dingdingadd (context, payload) {
            return D.add(payload)
        },
        //  详情
        dingdingdetails (context, payload) {
            payload.apikey = 'alarmconfig/dingdingdetails'
            return D.detail({
                ...payload
            }).then(response => {
                const { data } = response.data;
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })

        },

        //  查询邮箱配置列表
        searchEmailPage (context, payload) {
            return D.select({
                ...payload
            })
        },

        // 列表
        emaillist (context, payload) {
            return D.select({
                ...payload
            })

        },
        //  修改
        emailedit (context, payload) {
            return D.edit({
                ...payload
            })

        },
        //  删除
        emaildel (context, payload) {
            return D.edit({
                ...payload
            })
        },
        //  新增
        emailadd (context, payload) {
            return D.add(payload)
        },
        //  详情
        emaildetails (context, payload) {
            payload.apikey = 'alarmconfig/emaildetails'
            return D.detail({
                ...payload
            }).then(response => {
                const { data } = response.data;
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })

        },

        //  查询告警服务配置列表
        searchAlertconfigPage (context, payload) {
            return D.select({
                ...payload
            })
        },

        // 列表
        alertconfiglist (context, payload) {
            return D.select({
                ...payload
            })

        },
        //  修改
        alertconfigedit (context, payload) {
            return D.edit({
                ...payload
            })

        },
        //  删除
        alertconfigdel (context, payload) {
            return D.edit({
                ...payload
            })
        },
        //  新增
        alertconfigadd (context, payload) {
            return D.add(payload)
        },
        //  详情
        alertconfigdetails (context, payload) {
            payload.apikey = 'alarmconfig/alertconfigdetails'
            return D.detail({
                ...payload
            }).then(response => {
                const { data } = response.data;
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })

        },


        // 列表
        alerthistorylist (context, payload) {
            return D.select({
                ...payload
            })

        },

        //  详情
        alerthistorydetails (context, payload) {
            payload.apikey = 'alarmconfig/alerthistorydetails'
            return D.detail({
                ...payload
            }).then(response => {
                const { data } = response.data;
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })

        },

        getEmptySearch (context) {
            context.commit({
                type: 'save',
                payload: {
                    searchP: {
                        dingdingname: '',

                    }
                }
            })
        },
    }
}